import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import LanduseSelection from '../Site/SiteTable/LanduseSelection';
import ModeTypeSelection from '../TripRate/Filters/ModeTypeSelection';
import { useState, useEffect, useContext } from 'react';
import HelpLink from '../Popups/HelpLink';
import PDFLink from '../Popups/PDFLink';
import { SessionContext } from '../Contexts/SessionContext';
import AvailableDates from '../TripRate/Filters/PrimaryFiltering/AvailableDates';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

const landUseHelpPages = [
    { id: '01', page: 'Retail sub-categories' },
    { id: '02', page: 'Employment sub-categories' },
    { id: '03', page: 'Residential sub-categories' },
    { id: '04', page: 'Education sub-categories' },
    { id: '05', page: 'Health sub-categories' },
    { id: '06', page: 'Hotel, Food & Drink sub-categories' },
    { id: '07', page: 'Leisure sub-categories' },
    { id: '08', page: 'Marinas' },
    { id: '09', page: 'Golf sub-categories' },
    { id: '10', page: 'Tourist attractions' },
    { id: '12', page: 'Civic Amenity sub-categories' },
    { id: '13', page: 'Petrol Filling Station sub-categories' },
    { id: '14', page: 'Car Show Rooms' },
    { id: '15', page: 'Vehicle Services sub-categories' },
    { id: '16', page: 'Mixed sub-categories' },
    { id: '17', page: 'New Communities sub-categories' },
];

export default function LandusePage() {
    const navigate = useNavigate();
    const [link, setLink] = useState<string>('');
    const { sessionState } = useContext(SessionContext);

    useEffect(() => {
        setLink(landUseHelpPages.find(f => f.id == sessionState.tripRateMain)?.page ?? '');
    }, [sessionState.tripRateMain]);


    return (
        <Grid container alignItems="stretch">
            <Grid size={6} component={Paper}>
                <LanduseSelection area="TripRate" />
            </Grid>
            {(sessionState.tripRateMain === '16' || sessionState.tripRateMain === '17' || sessionState.tripRateMain === '10') ?
                <Typography variant="h6" sx={{ padding: 2 }}>This Land Use has no Parameters. The individual survey data can only be viewed in the Site List facility.</ Typography >
                :
                <>
                    <Grid size={6} component={Paper} container>
                        <Grid size={6}>
                            <Button onClick={() => navigate("/timeseriesanalysis")} variant="outlined">Time Series Analysis</Button>
                        </Grid>
                        <Grid size={6}>
                            <Button onClick={() => navigate("/triprate/filter")} variant="outlined">Search, Browse & Select Individual Sites</Button>
                        </Grid>
                        <Grid size={6}>
                            <HelpLink page={link} label="Land Use Definitions" />
                        </Grid>
                        <Grid size={6}>
                            <PDFLink label="Land Uses & Use Classes" container="GeneralDocs" file="TRICS Use Classes Land Uses" />
                        </Grid>
                    </Grid>

                    <Grid size={4}>
                        <ModeTypeSelection />
                    </Grid>
                    <Grid size={8}>
                        <AvailableDates />
                    </Grid>

                </>
            }
        </Grid>
    );
}

